// Quais etapas de pipeline usam uma etiqueta. Usado para AVISAR o usuário antes de excluir
// uma etiqueta na tela CORE de Etiquetas (Settings → Labels). A exclusão em si é segura
// (FK on delete cascade remove o vínculo), mas queremos consciência: "esta etiqueta está
// em uso por X etapas; excluí-la a remove delas".
//
// Função PURA e isolada (dev-kit) — recebe a etiqueta e a lista de pipelines do store
// (`pipelines/getPipelines`, cada pipeline com `stages[].label_ids`). Não toca o core.
export function stagesUsingLabel(label, pipelines) {
  const labelId = label?.id;
  if (!labelId || !Array.isArray(pipelines)) return [];

  return pipelines.flatMap(pipeline =>
    (pipeline.stages || [])
      .filter(stage => (stage.label_ids || []).includes(labelId))
      .map(stage => ({ pipeline: pipeline.name, stage: stage.name }))
  );
}
